import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AmadeusFlightState {
  selectedOffer: any | null;
}

const initialState: AmadeusFlightState = {
  selectedOffer: null,
};

const amadeusFlightSlice = createSlice({
  name: "amadeusFlight",
  initialState,
  reducers: {
    setSelectedOffer(state, action: PayloadAction<any>) {
      state.selectedOffer = action.payload;
    },
    clearSelectedOffer(state) {
      state.selectedOffer = null;
    },
  },
});

export const { setSelectedOffer, clearSelectedOffer } =
  amadeusFlightSlice.actions;
export default amadeusFlightSlice.reducer;
